import { render, staticRenderFns } from "./verifyCode.vue?vue&type=template&id=50f34a66&scoped=true"
import script from "./verifyCode.vue?vue&type=script&lang=js"
export * from "./verifyCode.vue?vue&type=script&lang=js"
import style0 from "./verifyCode.vue?vue&type=style&index=0&id=50f34a66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f34a66",
  null
  
)

export default component.exports